module.exports = __webpack_public_path__ + "img/chronicle-financial-300dpi.cfa87429.png";